var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBlogLinkedin = function SvgSvgBlogLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.526 15.75H.26V5.235h3.266V15.75ZM1.891 3.8C.847 3.8 0 2.936 0 1.891a1.891 1.891 0 1 1 3.783 0c0 1.045-.847 1.91-1.892 1.91Zm13.855 11.95h-3.258v-5.119c0-1.22-.025-2.784-1.698-2.784-1.699 0-1.959 1.325-1.959 2.696v5.207H5.57V5.235H8.7v1.434h.046c.436-.826 1.501-1.698 3.09-1.698 3.305 0 3.913 2.176 3.913 5.003v5.776h-.004Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.75v18H0z"
  })))));
};
export default SvgSvgBlogLinkedin;